import React from "react";
import { iconProps } from "../Helper";

const GreaterThanIcon = ({className}:iconProps) => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{overflow: "visible"}}
    >
      <path
      className={className}
        d="M8 4L13 9L8 14"
        stroke="#E5E2E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default GreaterThanIcon;
